
<template>
  <div class="grid grid-cols-2 gap-4">
    <div style="">
      <DxDropDownBox
        v-model:value="gridBoxValue1"
        v-model:opened="isGridBoxOpened"
        :defer-rendering="false"
        :display-expr="gridBoxDisplayExpr"
        :show-clear-button="true"
        :data-source="gridDataSource1"
        value-expr="id"
        placeholder="Select a module..."
      >
        <template #content="{ data }">
          <DxDataGrid
            :data-source="gridDataSource1"
            :columns="gridColumns"
            :hover-state-enabled="true"
            v-model:selected-row-keys="gridBoxValue1"
            @selection-changed="onGridSelectionChanged($event)"
            height="100%"
          >
            <DxSelection mode="single" />
            <DxPaging :enabled="true" :page-size="10" />
            <DxFilterRow :visible="true" />
            <DxScrolling mode="virtual" />
          </DxDataGrid>
        </template>
      </DxDropDownBox>
    </div>
    <div style="">    
      <DxDropDownBox
        v-model:value="gridBoxValue"
        v-model:opened="isGridBoxOpened2"
        :defer-rendering="false"
        :display-expr="gridBoxDisplayExpr"
        :show-clear-button="true"
        :data-source="gridDataSource2"
        value-expr="id"
        placeholder="Select a value..."
      >
        <template #content="{ data }">
          <DxDataGrid
            :data-source="gridDataSource2"
            :columns="gridColumns"
            :hover-state-enabled="true"
            v-model:selected-row-keys="gridBoxValue"
            @selection-changed="onGridSelectionChanged($event)"
            height="100%"
          >
            <DxSelection mode="single" />
            <DxPaging :enabled="true" :page-size="10" />
            <DxFilterRow :visible="true" />
            <DxScrolling mode="virtual" />
          </DxDataGrid>
        </template>
      </DxDropDownBox>
    </div>
  </div>
</template>
<script>
import DxDropDownBox from "devextreme-vue/drop-down-box";
import DxTreeView from "devextreme-vue/tree-view";
import {
  DxDataGrid,
  DxSelection,
  DxPaging,
  DxFilterRow,
  DxScrolling,
} from "devextreme-vue/data-grid";
import CustomStore from "devextreme/data/custom_store";
import dxDropDownBox from "devextreme/ui/drop_down_box";
import axios from "axios";



export default {
  props: {
    prefix:String,
    rRoute: String,
    fname:String,
    modelValue: {
      type: String,
      default: "",
      required: true,
    },
  },
  components: {
    DxDropDownBox,
    DxTreeView,
    DxDataGrid,
    DxSelection,
    DxPaging,
    DxFilterRow,
    DxScrolling,
  },
  data() {
    return {
      treeDataSource: null,
      treeBoxValue: null,
      gridDataSource1: null,
      gridDataSource2: null,
      isGridBoxOpened: false,
      isGridBoxOpened2: false,
      isTreeBoxOpened: false,
      gridBoxValue: [this.modelValue],
      treeViewRefName: "tree-view",
      gridColumns: ["name"],
    };
  },
  
  created() {       
      this.gridDataSource1 = this.makeAsyncDataSource(this.prefix,this.rRoute,"morphList",this.fname);
      
  },
  methods: {
    makeAsyncDataSource(prefix,rRoute,rFrom,rParam) {
      return new CustomStore({
        loadMode: "raw",
        key: "id",
        load: function () {
          let listurl = "/"+prefix+"/" + rRoute + "/" + rFrom;
          const params = {}
          if (rParam) { params.rname = rParam }

          return axios
            .get(listurl,{params})
            .then((response) => { 
              if(rFrom == 'morphList')
              return response.data.results;

              return response.data.results.data;
            })
            .catch(() => {
              throw "Data Loading Error";
            });
        },
      });
    },

    gridBoxDisplayExpr(item) {
      return item && `${item.name} <${item.label}>`;
    },
    onTreeItemClick() {
      this.isTreeBoxOpened = false;
    },

    onGridSelectionChanged(item) {
      
      //on item change check if module name change the refresh tha second dd by module name
      
      if(item.selectedRowsData.length >= 1)
      {
        this.$emit("update:modelValue", item.selectedRowsData[0].id);
        this.gridDataSource2 = this.makeAsyncDataSource(this.prefix,item.selectedRowsData[0].id,"list",null);

      }
      
      
      this.isGridBoxOpened2 = false;
      this.isGridBoxOpened = false;
    },
  },

  mounted() {
      
    
  },
};
</script>
<style scoped>
</style>